import { User } from '@apis/index'
import Button from '@components/button'
import Fields from '@components/fields'
import { AuthSchema } from '@validations/index'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthFooter from '../component/authFooter'
import AuthHeader from '../component/authHeader'
import {
  AuthCard,
  AuthContainer,
  AuthWrapper,
  BottomSection,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
} from '../style'
import GoBack from '@components/back'

const PhoneInputResetPassword = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const initialValues = {
    phoneNo: '',
    purpose: 'ResetPassword',
    countryCode: '977',
  }

  const sumbitHandler = async (values: any) => {
    setLoading(true)
    const payload = { ...values }
    await User.requestOtp(payload)
      .then((res) => {
        if (res) {
          navigate('/otp-verify-reset-password', {
            state: {
              ...payload,
              token: res.token,
            },
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <AuthWrapper>
      <AuthCard>
        <AuthContainer>
          <GoBack visibleForDesktop={false} />
          <AuthHeader content="Reset" tag="Password" />
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={AuthSchema.phoneValidationSchema}
            onSubmit={sumbitHandler}
          >
            {({ handleSubmit, setFieldValue }) => {
              return (
                <FormWrapper style={{ marginTop: 20 }}>
                  <Form onSubmit={handleSubmit}>
                    <FormContainer>
                      <FormInputsContainer>
                        <Fields.PhoneInput
                          placeholder="Mobile Number"
                          name="phoneNo"
                          label="Phone Number"
                          onChangeCode={(codes) => {
                            setFieldValue('countryCode', codes.callingCode)
                          }}
                        />
                      </FormInputsContainer>
                      <BottomSection>
                        <AuthFooter
                          content="Back to Login Page!"
                          tag="Login Now"
                          onClick={() => navigate('/login')}
                        />
                        <Button
                          title="Send OTP"
                          styleButton="width:100%"
                          height={45}
                          type="submit"
                          loading={loading}
                        />
                      </BottomSection>
                    </FormContainer>
                  </Form>
                </FormWrapper>
              )
            }}
          </Formik>
        </AuthContainer>
      </AuthCard>
    </AuthWrapper>
  )
}

export default PhoneInputResetPassword
